import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';
import { denormaliseData, normaliseData } from '../helpers';
import { IPortalPropertyPhotoAsset, IUpdateTitlePayLoad } from '../../../../interfaces/asset';

const useUpdatePhotoCaption = () => {
    const queryClient = useQueryClient();
    const queryKey = ['asset', 'photos'];
    return useMutation({
        mutationFn: assetApi.updatePhotoTitle,
        onMutate: async (update: IUpdateTitlePayLoad) => {
            // prevent any query updates while we perform optimistic update
            await queryClient.cancelQueries({ queryKey });

            // copy the current data as it exists in the react-query store
            const [previousKeyAndData]: any[] = queryClient.getQueriesData({
                queryKey
            });

            const oldData = previousKeyAndData?.[1] || [];

            queryClient.setQueriesData({ queryKey }, (data: IPortalPropertyPhotoAsset[]) => {        
                const normalisedData = normaliseData(data);
                normalisedData.photos[update.AssetID] = {
                    ...normalisedData.photos[update.AssetID],
                    Title: update.Title
                };

                return denormaliseData(normalisedData);
            });
            
            // this gets added to the context in case we need to rollback
            return { previous: oldData };
        },
        onError: (error, _, context) => {
            console.log(error);
            // Rollback to the previous state if mutation fails
            if (context?.previous) {
                queryClient.setQueryData(queryKey, context.previous);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey
            });
        }
    });
};

export { useUpdatePhotoCaption };